import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import { DateFormat } from "web_myplann/Shared/Utils/dateFormats";
import { optionalDateAsString } from "web_myplann/Shared/Validation/optionalDateAsString";
import { optionalPositiveFloat } from "web_myplann/Shared/Validation/optionalPositiveFloat";
import { trimmedNullable } from "web_myplann/Shared/Validation/trimmedNullable";
import { ValidationLimits } from "web_myplann/Shared/Validation/validationLimits";
import { z } from "zod";

export const getArtFormSchema = (t: TranslateFunction) => {
	const positiveNumberMessages = {
		positiveMessage: t(
			Resources.Portfolio.AddShared.Validations.positiveNumber,
		),
		maxMessage: t(Resources.Portfolio.AddShared.Validations.maxValue),
	};
	return z.object({
		propertyType: trimmedNullable(
			z
				.string()
				.min(1, t(Resources.Portfolio.AddShared.Validations.required))
				.max(
					ValidationLimits.TextLength.Name,
					t(Resources.Portfolio.AddShared.Validations.maxLength, {
						max: ValidationLimits.TextLength.Name,
					}),
				),
		),
		customDisposition: trimmedNullable(
			z.string().max(
				ValidationLimits.TextLength.Disposition,
				t(Resources.Portfolio.AddShared.Validations.maxLength, {
					max: ValidationLimits.TextLength.Disposition,
				}),
			),
		),
		purchaseDate: optionalDateAsString(DateFormat.Iso),
		description: trimmedNullable(
			z.string().max(
				ValidationLimits.TextLength.Note,
				t(Resources.Portfolio.AddShared.Validations.maxLength, {
					max: ValidationLimits.TextLength.Note,
				}),
			),
		),
		value: optionalPositiveFloat(
			ValidationLimits.Amount.Max,
			positiveNumberMessages,
		),
		forInvestments: z.boolean(),
	});
};

export type ArtFormInput = z.input<ReturnType<typeof getArtFormSchema>>;
export type ArtFormOutput = z.output<ReturnType<typeof getArtFormSchema>>;
